import { render, staticRenderFns } from "./kategories-dialog.vue?vue&type=template&id=0c2f65a8"
import script from "./kategories-dialog.vue?vue&type=script&lang=js"
export * from "./kategories-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports